import React from 'react'
import axios from 'axios'
import api from '../../../utils/API';
import { FormattedMessage } from 'react-intl';
import InputValidation from '../../../utils/InputValidation';

class SSOVerifyAccount extends React.Component {
  state = {
    enterCode: '',
    error: '',
    displayString: '',
    disableResend: false,
  }

  componentDidMount = () => {
  };

  handleChange = (event) => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value
    this.setState({ [event.target.name]: value })
  }

  handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      this.handleLogIn(event)
    }
  }

  errorMessage = (err) => {
    switch(err.response.status) {
      case 400:
        this.setState({ error: <FormattedMessage id="INVALID_PARAMETERS" /> })
        break;
      case 401:
      case 500:
        this.setState({ error: <FormattedMessage id={err.response.data.toUpperCase()} /> })
        break;
      default:
        this.setState({ error: err.message })
    }
  }

  handleConfirm = (event) => {
    event.preventDefault()
    let empty = InputValidation.validateEmpty(this.state.enterCode);
    if(empty !== ""){
      this.setState({error: <span><FormattedMessage id={empty} /><FormattedMessage id="ENTER_CODE" /></span>}); 
      return;
    }
    api.verifyEmail(this.props.email, this.state.enterCode)
    .then(res => {
      const { data } = res
      if (data.error) return this.setState({ error: data.error })
      this.props.onSignIn();
    }).catch(err => {
      console.error(err)
      this.errorMessage(err);
    })
  }

  resendCode = (event) => {
    event.preventDefault()
    this.setState({ disableResend: true })
    api.resendVerifyForCMSECreateAccount(this.props.email)
      .then(() => {
        console.log('Successfully resent to', this.props.email);
        setTimeout(()=>{
          this.setState({ disableResend: false })
        }, 10000)       
    })
    .catch(err => {
      this.setState({ error: err.message, disableResend: false })     
    })
  }

    render() {
        return(
            <div className='card'>
                <div className='header text-center'>
                  <h2><FormattedMessage id="VERIFY_ACCOUNT_TITLE" /></h2>
                </div>
                <div className='form-outline mt-2 mb-2 text-center'>
                  <label className='form-label'><FormattedMessage id="RESEND_VERIFICATION_EMAIL_SENT"/></label>
                </div> 
                <button type='button' className='btn btn-primary btn-block' onClick={this.props.onSignIn}><FormattedMessage id="DONE_BTN" /></button>
                {/*
                <div className='header text-center'>
                  <h2><FormattedMessage id="VERIFY_ACCOUNT_TITLE" /></h2>
                  <h3><FormattedMessage id="VERIFY_ACCOUNT_SUB_TITLE" values={{email: <span>{this.props.email.replace(/^.{3}/, '*******')}</span>}}/></h3>
                </div>
                <div className='form-outline mt-2 mb-2'>
                    <label className='form-label' htmlFor='form2Example1'><FormattedMessage id="ENTER_CODE" /></label>
                    <input onChange={this.handleChange} value={this.state.enterCode} name='enterCode' type='enterCode' className='form-control rounded-1' />
                </div>
                {this.state.error ? <p className='error'><FormattedMessage id="ERROR" />{this.state.error}</p> : null}
                <button type='button' className='btn btn-primary btn-block' onClick={this.handleConfirm}><FormattedMessage id="CONFIRM_BTN" /></button>
                <div className='mt-2 text-center'>
                    <label className='form-label'><FormattedMessage id="DIDNT_RECV_CODE" /></label>
                    <label className={'form-label red ms-2 ' + (this.state.disableResend ? 'label_disabled' : 'label_hover')} onClick={this.state.disableResend ? null : this.resendCode}><FormattedMessage id="RESEND_CODE" /></label>
                </div>
                */}
            </div>
        )
    }
}

export default SSOVerifyAccount;